export default {
  request: {
    title: 'You’re pencilled in!',
    subtitle: 'Thanks {learner}, you’ve made a provisional booking with {advisor}. They\'ll get back to you shortly to confirm.',
    nextSteps: {
      title: 'What happens next?',
      steps: [
        { step: '{advisor} will review your booking details', },
        { step: 'They\'ll either confirm your booking at one of the times requested' },
        { step: 'Or suggest other times that may work', },
        // Payment only
        { step: 'You’ll only be charged if the booking is confirmed by {advisor}' },
        { step: 'We’ll remind you when your booking is coming up' },
        { step: 'You get to enjoy your Kintell video session!' },
      ],
      freeSteps: [
        { step: '{advisor} will review your booking details', },
        { step: 'They\'ll either confirm your booking at one of the times requested' },
        { step: 'Or suggest other times that may work', },
        { step: 'We’ll remind you when your booking is coming up' },
        { step: 'You get to enjoy your Kintell video session!' },
      ]
    },
    cta: {
      label: 'My Bookings',
      link: '/my-kintell/bookings/requests'
    },
    send: 'MAKE PROVISIONAL BOOKING'
  },
  cancelled: {
    title: 'Booking cancelled',
    subtitle: 'Your booking with {name} has been cancelled.',
  },
  confirmed: {
    title: 'Booking confirmed!',
    subtitle: 'Thanks {advisor}, your booking with {learner} is confirmed and in your Kintell Calendar!',
  },
  suggested: {
    title: 'Alternative times sent!',
    subtitle: 'Thanks {advisor}, we\'ve sent your suggested times over to {learner} - we\'ll let you know when they respond.',
  },
  reschedule: {
    title: 'Booking Rescheduled!',
    subtitle: 'Thanks {sender}, we\'ve sent the new times to {recipient} to review - we\'ll let you know when they respond.',
  },
  review: {
    title: 'Please leave a review',
    request: 'Please leave your review of {name}, following your booking on {date}.',
    nextPage: 'And we\'ll show your booking summary',
    button: 'Submit Review'
  },
  initiate: {
    hint: 'Use this page when you\'d like to invite someone to book you on Kintell. Select some times to suggest, and then either pop in an email address or copy the booking invite URL and share it!',
    submit: 'Continue to sharing details',
    send: 'Send'
  }
}
